import Vue from 'vue';

Vue.filter('currencyInteger', value => {
  
    return (value / 100).toFixed(2) + '\u00A0€'
});
